export default __webpack_public_path__ + "static/media/paper-light.e35f1a84.svg";